import { z } from 'zod';

export * from './prefixes.js';

export const PAYMENT_METHODS = ['autogiro', 'efaktura', 'manuellt'] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const CATEGORY_GROUPS = [
  'Boende',
  'Lån',
  'Försäkringar',
  'Sparande',
  'Personligt',
  'Vardagsutgifter',
] as const;
export type CategoryGroup = (typeof CATEGORY_GROUPS)[number];

export const IMPORT_SOURCES = ['nordea_csv', 'manual'] as const;
export type ImportSource = (typeof IMPORT_SOURCES)[number];

export const MEMBER_ROLES = ['owner', 'member'] as const;
export type MemberRole = (typeof MEMBER_ROLES)[number];

export const INVITATION_STATUSES = ['pending', 'accepted', 'declined', 'expired'] as const;
export type InvitationStatus = (typeof INVITATION_STATUSES)[number];

export const MATCH_TYPES = ['contains', 'exact', 'starts_with'] as const;
export type MatchType = (typeof MATCH_TYPES)[number];

export const IMPORT_BATCH_STATUSES = ['pending', 'confirmed', 'rejected'] as const;
export type ImportBatchStatus = (typeof IMPORT_BATCH_STATUSES)[number];

export const PaymentMethodSchema = z.enum(PAYMENT_METHODS);
export const MemberRoleSchema = z.enum(MEMBER_ROLES);
export const InvitationStatusSchema = z.enum(INVITATION_STATUSES);
export const MatchTypeSchema = z.enum(MATCH_TYPES);
export const ImportSourceSchema = z.enum(IMPORT_SOURCES);
export const ImportBatchStatusSchema = z.enum(IMPORT_BATCH_STATUSES);

// ── Bank sources ─────────────────────────────────────────────────────────────

export const BANK_SOURCES = ['nordea'] as const;
export type BankSource = (typeof BANK_SOURCES)[number];

export const BankSourceSchema = z.enum(BANK_SOURCES);

// ── Generic description blocklist ────────────────────────────────────────────

/** Descriptions matching only these terms (case-insensitive) are capped at confidence 50 */
export const GENERIC_DESCRIPTION_BLOCKLIST = [
  'kortköp',
  'swish',
  'överföring',
  'overforing',
  'betalning',
  'insättning',
  'uttag',
] as const;

/** Maximum confidence for rules matching only generic descriptions */
export const GENERIC_CONFIDENCE_CAP = 50;
